import { useId } from "react";
import { Group } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@trillion/ui/components/ui/dropdown-menu";
import type { OrganizationAction } from "../types/board";
import { ORGANIZATION_LABELS, type OrganizationAvailability } from "../lib/canvas-organization";

export type CanvasOrganizationMenuProps = {
  actions: OrganizationAvailability;
  onAction: (action: OrganizationAction) => void;
  selectionSummary: string;
  onClose?: () => void;
};

export function CanvasOrganizationMenu({ actions, onAction, selectionSummary, onClose }: CanvasOrganizationMenuProps) {
  const summaryId = useId();
  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="ghost" size="sm" className="h-9 gap-1 px-2" aria-label="Organize">
        <Group className="h-4 w-4" /><span className="text-xs">Organize</span>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent side="top" align="start" className="max-h-[min(80vh,42rem)] w-80 max-w-[calc(100vw-2rem)] overflow-y-auto" aria-describedby={summaryId}
      onCloseAutoFocus={event => { if (onClose) { event.preventDefault(); onClose(); } }}>
      <p id={summaryId} className="px-2 py-1.5 text-xs text-muted-foreground">{selectionSummary}</p>
      {(Object.entries(ORGANIZATION_LABELS) as [OrganizationAction, string][]).map(([action, label]) => <div key={action}>
        {["left", "horizontal", "forward"].includes(action) && <DropdownMenuSeparator />}
        <DropdownMenuItem aria-label={label} aria-describedby={actions[action].reason ? `${summaryId}-${action}` : undefined}
          disabled={!actions[action].enabled} onSelect={() => onAction(action)} className="flex-col items-start gap-0.5 whitespace-normal break-words">
          <span>{label}</span>
          {actions[action].reason && <span id={`${summaryId}-${action}`} className="text-xs">{actions[action].reason}</span>}
        </DropdownMenuItem>
      </div>)}
    </DropdownMenuContent>
  </DropdownMenu>;
}
